/* global getGAEventTrackingCode */

const jQuery = window.jQuery;
const $ = jQuery;
const HG = window.HG || (window.HG = {});

const BaseUrl = `${window.location.protocol}//${window.location.hostname}`;
import React from 'react';
import ReactDOM from 'react-dom';
import CategoryGQAutocomplete from './components/getquotes-category-autocomplete';
import CategoryDirectoryAutocomplete from './components/directory-category-autocomplete';
import PostcodeAutocomplete from '../../_common/scripts/components/postcode-autocomplete';
import { Theme, SearchBar } from 'hui/dist/styled';
import { ThemeProvider } from 'styled-components';
import Cookie from 'js-cookie';
// import slick
import 'slick-carousel/slick/slick';
import 'jquery-placeholder';
import './components/modal'; // todo do this properly

import YoutubePlayer from './components/youtube-player';

import preloadImage from '../../_common/scripts/utils/preload-image';

const stringify = (obj) => {
  try {
    return JSON.stringify(obj);
  } catch (e) {
    return null;
  }
};
const parse = (obj) => {
  try {
    return JSON.parse(obj);
  } catch (e) {
    return null;
  }
};

function doSearch(category = '', postcode = '') {
  const params = {
    search_str: category.replace(/\s/g, '+'),
    search_zip: postcode.replace(/\s/g, '+'),
    m: 'search',
    a: 'search_results',
    dosql: 'do_search',
    search_code: 'p',
    search_what_header: 'what',
    search_where_header: 'where',
    loctype: 'zip'
  };

  const query = Object.keys(params)
    .reduce((accum, p) => [...accum, `${p}=${params[p]}`], [])
    .join('&');

  if (!category) {
    window.location.href = `${BaseUrl}/find`;
  } else {
    window.location.href = `${BaseUrl}/index.php?m=search&a=search_results&${query}`;
  }
}

class Homepage {
  init() {
    $(() => {
      // toggling hero forms
      $('#heroGetQuotes a').on('click', (e) => {
        e.preventDefault();
        $('#heroGetQuotes')
          .removeClass('hero__form-inline')
          .addClass('hero__form-inline--hidden')
          .attr('style', '');
        $('#heroDirectory')
          .fadeIn()
          .removeClass('hero__form-inline--hidden')
          .addClass('hero__form-inline');
      });
      $('#heroDirectory a').on('click', (e) => {
        e.preventDefault();
        $('#heroDirectory')
          .removeClass('hero__form-inline')
          .addClass('hero__form-inline--hidden')
          .attr('style', '');
        $('#heroGetQuotes')
          .fadeIn()
          .removeClass('hero__form-inline--hidden')
          .addClass('hero__form-inline');
      });

      // recommendations
      const recommendationsSlick = {
        centerMode: true,
        slidesToShow: 5,
        focusOnSelect: true,
        pauseOnFocus: true,
        pauseOnHover: true,
        swipeToSlide: true,
        variableWidth: true,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              centerMode: true,
              slidesToShow: 3
            }
          },
          {
            breakpoint: 480,
            settings: {
              centerMode: true,
              slidesToShow: 1
            }
          }
        ]
      };

      $('.articles__carousel').slick({
        slidesToShow: 1,
        autoplay: false,
        dots: true
      });

      $('.how-it-works__row').slick({
        slidesToShow: 3,
        swipeToSlide: false,
        autoplay: false,
        dots: false,
        arrows: false,
        responsive: [
          {
            breakpoint: 770,
            settings: {
              slidesToShow: 1,
              dots: true
            }
          }
        ]
      });

      $('.top-categories__carousel').slick({
        slidesToShow: 5,
        swipeToSlide: false,
        autoplay: false,
        dots: false,
        arrows: false,
        responsive: [
          {
            breakpoint: 995,
            settings: {
              slidesToShow: 3,
              arrows: true,
              appendArrows: $('.top-categories__arrows')
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              dots: true
            }
          }
        ]
      });

      const track = window.pageTracker._trackEvent; // eslint-disable-line no-underscore-dangle
      const optimzleyGoal = () => {
        window.optimizely = window.optimizely || [];
        window.optimizely.push(['trackEvent', 'search_interaction']);
      };
      // init react elements
      // hero
      if ($('.hero__autosuggest').length) {
        let scrolled = false;

        const scrollToSearch = () => {
          if (!scrolled && window.innerWidth < 768) {
            $('html,body').animate({ scrollTop: $('div.hero__autosuggest').offset().top - 20 });
            scrolled = true;
          }
        };

        const suggestionTypes = {
          'Let us find you': 'Post Job',
          'Browse ': 'Directory'
        };

        const getSuggestionType = suggestion => suggestionTypes[suggestion.prefix_text] || 'Business';
        ReactDOM.render(
          <ThemeProvider theme={Theme}>
            <SearchBar
              onSubmit={(url) => {
                optimzleyGoal();
                track('Homepage', 'Submit Search', url);
                window.location = url;
              }}
              onSuggestionSelected={(suggestion, suggestionValue) =>
                track(
                  'Header',
                  `Select ${getSuggestionType(suggestion)} Search Result`,
                  suggestionValue
                )
              }
              initialLocation={parse(Cookie.get('location'))}
              onLocationDidChange={value => (value ? Cookie.set('location', stringify(value)) : Cookie.remove('location'))}
              onFocusLocation={() => {
                scrollToSearch();
                track('Homepage', 'Focus Location Autocompelete');
              }}
              onBlurLocation={() => track('Homepage', 'Blur Location Autocompelete')}
              onFocusAutosuggest={() => {
                scrollToSearch();
                track('Homepage', 'Focus Suggest Autocompelete');
              }}
              onBlurAutosuggest={() => track('Homepage', 'Blur Suggest Autocompelete')}
            />
          </ThemeProvider>,
          document.querySelector('.hero__autosuggest')
        );
      }
      // seo strip
      ReactDOM.render(
        <PostcodeAutocomplete classPrefix="top-categories__postcode" placeholder="Search your postcode" />,
        document.getElementById('topCategoriesPostcodeAutocomplete')
      );
      ReactDOM.render(
        <CategoryDirectoryAutocomplete classPrefix="top-categories__category" />,
        document.getElementById('topCategoriesCategoryAutocomplete')
      );
      ReactDOM.render(
        <CategoryGQAutocomplete
          classPrefix="search-bar__category"
          placeholder="Search for a Plumber, Electrician, Carpenter etc"
        />,
        document.getElementById('getQuotesAutocomplete')
      );

      // form submits
      $('#heroGetQuotes').on('submit', (e) => {
        e.preventDefault();
        optimzleyGoal();
        getGAEventTrackingCode(
          'Homepage',
          'Homepage - Form Submit Hero - Get Quotes',
          'Homepage - Form Submit Hero - Get Quotes'
        );
        const categoryKey = $('#heroGetQuotes .hero__gq-category-key').val();
        if (categoryKey) {
          window.location.href = `${BaseUrl}/find/${categoryKey}/get_quotes_simple`;
        } else {
          const inputVal = $('#heroGetQuotes .hero__gq-category__input').val();
          window.location.href = `${BaseUrl}/get_quotes_simple?search_str=${inputVal}`;
        }
      });

      $('#heroDirectory').on('submit', (e) => {
        e.preventDefault();
        optimzleyGoal();
        getGAEventTrackingCode(
          'Homepage',
          'Homepage - Form Submit Hero - Directory',
          'Homepage - Form Submit Hero - Directory'
        );
        const category = $('#heroDirectory .hero__directory-category__input').val();
        const postcode = $('#heroDirectory .hero__directory-postcode__input').val();
        doSearch(category, postcode);
      });

      $('#topCategories').on('submit', (e) => {
        e.preventDefault();
        getGAEventTrackingCode(
          'Homepage',
          'Homepage - Form Submit Categories - Directory',
          'Homepage - Form Submit Categories - Directory'
        );
        const category = $('#topCategories .top-categories__category__input').val();
        const postcode = $('#topCategories .top-categories__postcode__input').val();
        doSearch(category, postcode);
      });

      $('#getQuotes').on('submit', (e) => {
        e.preventDefault();
        getGAEventTrackingCode(
          'Homepage',
          'Homepage - Form Submit Bottom Search - Get Quotes',
          'Homepage - Form Submit Bottom Search - Get Quotes'
        );
        const categoryKey = $('#getQuotes .search-bar__category-key').val();
        if (categoryKey) {
          window.location.href = `${BaseUrl}/find/${categoryKey}/get_quotes_simple`;
        } else {
          const inputVal = $('#getQuotes .search-bar__category__input').val();
          window.location.href = `${BaseUrl}/get_quotes_simple?search_str=${inputVal}`;
        }
      });

      /* stops videos from continuing to play when modal is closed
      * todo maybe tidy this up??
      * */

      const adUrl = `https://www.youtube.com/embed/${$('#hipages-ad-iframe').data('id')}?autoplay=1`;

      $('#hipages-ad').on('hide.bs.modal', () => {
        $('#hipages-ad-iframe iframe').attr('src', '');
      });

      $('#hipages-ad').on('show.bs.modal', () => {
        $('#hipages-ad-iframe iframe').attr('src', adUrl);
      });

      const tradieUrl = `https://www.youtube.com/embed/${$('#tradie-video-iframe').data('id')}?autoplay=1`;

      $('#tradie-video').on('hide.bs.modal', () => {
        $('#tradie-video-iframe iframe').attr('src', '');
      });

      $('#tradie-video').on('show.bs.modal', () => {
        $('#tradie-video-iframe iframe').attr('src', tradieUrl);
      });

      $('input, textarea').placeholder();

      // replace preload images
      preloadImage(window, $, false);

      // don't block page rendering
      $(window).load(() => {
        const yt = new YoutubePlayer();
        yt.init();

        // recommendations
        $.ajax({
          type: 'GET',
          url: '/get_recommendations/all/?items=10',
          dataType: 'json',
          success(results, status) {
            if (status === 'success' && results.length > 0) {
              const html = results.reduce(
                (tmp, result) => `${tmp}<div class="recommendations__card" data-label="recommendations__card">
                  <div class="recommendations__card-block" style="background-image:url('${result.backgroundImage}');">
                    <div class="recommendations__card-text">
                      <div class="recommendations__card-business" data-label="recommendations__card-business">
                        ${result.site}
                      </div>
                      <div class="recommendations__card-category" data-label="recommendations__card-category">
                        ${result.category}
                      </div>
                      "${result.text}"
                    </div>
                    <p class="recommendations__card-date" data-label="recommendations__card-date">${result.date}</p>
                    <p 
                       class="recommendations__card-user-initial user-initial__${result.userInitial.toLowerCase()}"
                       data-label="recommendations__card-user-initial"
                        >${result.userInitial.toUpperCase()}
                    </p>
                    <p class="recommendations__card-user" data-label="recommendations__card-user">${result.user}</p>
                    <p class="recommendations__card-suburb" data-label="recommendations__card-suburb">${result.suburb}</p>
                  </div>
                </div>`,
                ''
              );

              $('.recommendations')
                .html(html)
                .slick(recommendationsSlick);
            }
          }
        });
      });
    });
  }
}
export default Homepage;

HG.Homepage = new Homepage();
HG.Homepage.init();



// WEBPACK FOOTER //
// ./homepage/scripts/main.js